import { render, staticRenderFns } from "./projectDetailReport.vue?vue&type=template&id=979f0c8c&"
import script from "./projectDetailReport.vue?vue&type=script&lang=ts&"
export * from "./projectDetailReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports